/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/de';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Auf Pretty HTML-Editor zugreifen"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Zugangskontrolle"
  },
  "action_to_take_b626a99a": {
    "message": "Auszuführende Tätigkeiten:"
  },
  "add_8523c19b": {
    "message": "Hinzufügen"
  },
  "add_a_caption_2a915239": {
    "message": "Eine Beschriftung hinzufügen"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Alternativen Text für das Bild hinzufügen"
  },
  "add_another_f4e50d57": {
    "message": "Einen weiteren hinzufügen"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "CC / Untertitel hinzufügen"
  },
  "add_image_60b2de07": {
    "message": "Bild hinzufügen"
  },
  "add_one_9e34a6f8": {
    "message": "Eine hinzufügen!"
  },
  "additional_considerations_f3801683": {
    "message": "Zusätzliche Überlegungen"
  },
  "address_applied_64269b0b": {
    "message": "Adresse angewendet"
  },
  "address_removed_fcb496e0": {
    "message": "Adresse entfernt"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Nebenstehende Links mit dem gleichen URL sollten ein einziger Link sein."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Ausrichten"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Ausrichtung und Listen"
  },
  "all_4321c3a1": {
    "message": "Alle"
  },
  "all_apps_a50dea49": {
    "message": "Alle Apps"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Herunterladen von Medien erlauben"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Herunterladen von Transkripten erlauben"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "In alphabetischer Reihenfolge"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Der alternative Text sollte nicht länger als 120 Zeichen sein."
  },
  "alt_text_611fb322": {
    "message": "Altern. Text"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Koprodukt)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Fehler beim Lesen der Datei"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Fehler beim einer Netzwerkanforderung"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Fehler beim Hochladen der Medien."
  },
  "and_7fcc2911": {
    "message": "Und"
  },
  "angle_c5b4ec50": {
    "message": "Winkel"
  },
  "announcement_fb4cb645": {
    "message": "Ankündigung"
  },
  "announcement_list_da155734": {
    "message": "Ankündigungsliste"
  },
  "announcements_a4b8ed4a": {
    "message": "Ankündigungen"
  },
  "apply_781a2546": {
    "message": "Anwenden"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Änderungen auf alle Instanzen dieses Icon Maker-Symbols im Kurs anwenden"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Nähert sich dem Grenzwert"
  },
  "approximately_e7965800": {
    "message": "Ungefähr"
  },
  "apps_54d24a47": {
    "message": "Apps"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Möchten Sie wirklich abbrechen? Vorgenommene Änderungen werden nicht gespeichert."
  },
  "arrows_464a3e54": {
    "message": "Pfeile"
  },
  "art_icon_8e1daad": {
    "message": "Kunstsymbol"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Seitenverhältnis wird beibehalten"
  },
  "assignment_976578a8": {
    "message": "Aufgabe"
  },
  "assignments_1e02582c": {
    "message": "Aufgaben"
  },
  "asterisk_82255584": {
    "message": "Sternchen"
  },
  "attributes_963ba262": {
    "message": "Attribute"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Aufzeichnung von Audio und Video wird nicht unterstützt, bitte nutzen Sie einen anderen Browser."
  },
  "audio_options_feb58e2c": {
    "message": "Audiooptionen"
  },
  "audio_options_tray_33a90711": {
    "message": "Fach für Audiooptionen"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Audioplayer für { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Automatisch gespeicherte Inhalte vorhanden. Möchten Sie lieber die automatisch gespeicherten Inhalte laden?"
  },
  "available_folders_694d0436": {
    "message": "Verfügbare Ordner"
  },
  "background_1bc88842": {
    "message": "Hintergrund"
  },
  "backslash_b2d5442d": {
    "message": "Umgekehrter Schrägstrich"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Grundlegend"
  },
  "because_501841b": {
    "message": "Weil"
  },
  "below_81d4dceb": {
    "message": "Unten"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Großer Kreis"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomischer Koeffizient"
  },
  "black_4cb01371": {
    "message": "Schwarz"
  },
  "blue_daf8fea9": {
    "message": "Blau"
  },
  "bold_applied_42d547b7": {
    "message": "Fettschrift angewendet"
  },
  "bold_removed_da474a5c": {
    "message": "Fettschrift entfernt"
  },
  "border_5b08b06d": {
    "message": "Rand"
  },
  "bottom_15a2a9be": {
    "message": "Unten"
  },
  "bottom_third_5f5fec1d": {
    "message": "Unteres Drittel"
  },
  "bowtie_5f9629e4": {
    "message": "Fliege"
  },
  "brick_f2656265": {
    "message": "Ziegelrot"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "© 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Abbrechen"
  },
  "cap_product_3a5265a6": {
    "message": "Cap-Produkt"
  },
  "caption_manager_aae0906f": {
    "message": "Untertitel-Manager"
  },
  "center_align_e68d9997": {
    "message": "Mittig ausrichten"
  },
  "centered_dot_64d5e378": {
    "message": "Zentrierter Punkt"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Zentrierte horizontale Punkte"
  },
  "change_alt_text_92654906": {
    "message": "Alt. Text ändern"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Überschrifts-Tag zu Absatz ändern"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Nur die Ebene dieser Überschrift ändern"
  },
  "change_text_color_1aecb912": {
    "message": "Textfarbe ändern"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Änderungen werden nach dem Speichern der Seite angewendet."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Vorgenommene Änderungen werden nicht gespeichert."
  },
  "characters_9d897d1c": {
    "message": "Zeichen"
  },
  "characters_no_spaces_485e5367": {
    "message": "Zeichen (ohne Leerzeichen)"
  },
  "check_accessibility_3c78211c": {
    "message": "Zugänglichkeit prüfen"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Zugangsprobleme werden überprüft"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Caption-Datei auswählen"
  },
  "choose_usage_rights_33683854": {
    "message": "Nutzungsrechte auswählen ...."
  },
  "circle_484abe63": {
    "message": "Kreis"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "Ungeordnete Liste einkreisen"
  },
  "clear_2084585f": {
    "message": "Löschen"
  },
  "clear_image_3213fe62": {
    "message": "Bild löschen"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klicken oder Umschalt-Taste / Klicken für den html-Editor."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "{ imageName } durch Anklicken einbetten"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Vorschau ausblenden"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Einfügen eines Links in den Editor"
  },
  "click_to_show_preview_faa27051": {
    "message": "Vorschau einblenden"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Menü oder Dialogfeld schließen. Bringt Sie zurück zum Editor-Bereich"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Zugangsprüfung schließen"
  },
  "close_d634289d": {
    "message": "Schließen"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Tastenkombination-Modal schließen"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Die Untertiteldatei muss kleiner als { maxKb } KB sein."
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Untertitel"
  },
  "clubs_suit_c1ffedff": {
    "message": "Kreuz (Spielkartenfarbe)"
  },
  "collab_575ac7bc": {
    "message": "Collab"
  },
  "collaborations_5c56c15f": {
    "message": "Collaborations"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "{ types } ausblenden"
  },
  "color_a363e1b0": {
    "message": "Farbe"
  },
  "color_contrast_4c418add": {
    "message": "Farbkontrast"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Farbkontrastverhältnis"
  },
  "color_picker_6b359edf": {
    "message": "Farbwähler"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Farbwähler ({ colorName } ausgewählt)"
  },
  "color_popup_af39810f": {
    "message": "Farb-Popup"
  },
  "column_e1ae5c64": {
    "message": "Spalte"
  },
  "column_group_1c062368": {
    "message": "Spaltengruppe"
  },
  "complex_numbers_a543d004": {
    "message": "Komplexe Zahlen"
  },
  "computer_1d7dfa6f": {
    "message": "Computer"
  },
  "congruent_5a244acd": {
    "message": "Kongruent"
  },
  "contains_311f37b7": {
    "message": "Enthält"
  },
  "content_1440204b": {
    "message": "Inhalt"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Inhalt im Editor wird geändert Klicken Sie auf „Abbrechen“, um den originlaen Inhalt beizubehalten."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Der Inhalt wird noch hochgeladen, wenn Sie fortfahren, wird er nicht richtig eingebettet."
  },
  "content_subtype_5ce35e88": {
    "message": "Inhalt-Subtyp"
  },
  "content_type_2cf90d95": {
    "message": "Inhalt-Typ"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Weiter zu YouTube-Inhalt"
  },
  "coproduct_e7838082": {
    "message": "Koprodukt"
  },
  "copyright_holder_66ee111": {
    "message": "Urheberrechtsinhaber:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Inhalt konnte nicht eingefügt werden: { itemType }-Elemente werden derzeit in Canvas nicht unterstützt."
  },
  "count_40eced3b": {
    "message": "Anzahl"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 Worte}\n    one {1 Wort}\n  other {# Worte}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# Objekt geladen}\n  other {# Objekte geladen}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Kursdokumente"
  },
  "course_files_62deb8f8": {
    "message": "Kursdateien"
  },
  "course_files_a31f97fc": {
    "message": "Kursdateien"
  },
  "course_images_f8511d04": {
    "message": "Kursbilder"
  },
  "course_link_b369426": {
    "message": "Link zum Kurs"
  },
  "course_links_b56959b9": {
    "message": "Kurs-Links"
  },
  "course_media_ec759ad": {
    "message": "Kursmedien"
  },
  "course_navigation_dd035109": {
    "message": "Kursnavigation"
  },
  "create_icon_110d6463": {
    "message": "Symbol „Erstellen“"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Icon Maker erstellen-Symbol"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons-Lizenz:"
  },
  "crop_image_41bf940c": {
    "message": "Bild zuschneiden"
  },
  "crop_image_807ebb08": {
    "message": "Bild zuschneiden"
  },
  "cup_product_14174434": {
    "message": "Cup-Produkt"
  },
  "current_image_f16c249c": {
    "message": "Aktuelles Bild"
  },
  "current_link_945a47ee": {
    "message": "Aktueller LInk"
  },
  "current_volume_level_c55ab825": {
    "message": "Aktuelle Lautstärke"
  },
  "custom_6979cd81": {
    "message": "Angepasst"
  },
  "cyan_c1d5f68a": {
    "message": "Cyan"
  },
  "dagger_57e0f4e5": {
    "message": "Kreuzzeichen"
  },
  "date_added_ed5ad465": {
    "message": "Datum hinzugefügt"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Dekoratives Symbol"
  },
  "decorative_image_fde98579": {
    "message": "Dekoratives Bild"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekorativer { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Einzug verkleinern"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Rich-Content-Bereich verkleinern"
  },
  "deep_purple_bb3e2907": {
    "message": "Dunkelviolett"
  },
  "default_9db103d": {
    "message": "Standard"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "Ungeordnete Liste standardmäßig mit Aufzählungszeichen"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "Standardmäßig numerisch sortierte Liste"
  },
  "definite_integral_fe7ffed1": {
    "message": "Bestimmtes Integral"
  },
  "degree_symbol_4a823d5f": {
    "message": "Gradsymbol"
  },
  "delimiters_4db4840d": {
    "message": "Trennzeichen"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Das Symbol beschreiben)"
  },
  "describe_the_type_ff448da5": {
    "message": "(beschreiben Sie den { TYPE })"
  },
  "description_436c48d7": {
    "message": "Beschreibung"
  },
  "details_98a31b68": {
    "message": "Details"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Diagonale Punkte"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamond"
  },
  "diamonds_suit_526abaaf": {
    "message": "Karo (Spielkartenfarbe)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Dimensionstyp"
  },
  "directionality_26ae9e08": {
    "message": "Schreibrichtung"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "LaTeX direkt bearbeiten"
  },
  "disable_preview_222bdf72": {
    "message": "Vorschau deaktivieren"
  },
  "discussion_6719c51d": {
    "message": "Diskussion"
  },
  "discussions_a5f96392": {
    "message": "Diskussionen"
  },
  "discussions_index_6c36ced": {
    "message": "Diskussionsindex"
  },
  "disjoint_union_e74351a8": {
    "message": "Disjunkte Vereinigung"
  },
  "display_options_315aba85": {
    "message": "Anzeigeoptionen"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Text-Link anzeigen (wird in einem neuen Tab geöffnet)"
  },
  "div_applied_49ad83fc": {
    "message": "Div angewendet"
  },
  "div_removed_d13f8e17": {
    "message": "Div entfernt"
  },
  "division_sign_72190870": {
    "message": "Divisionszeichen"
  },
  "document_678cd7bf": {
    "message": "Dokument"
  },
  "documents_81393201": {
    "message": "Dokumente"
  },
  "done_54e3d4b6": {
    "message": "Fertig"
  },
  "double_dagger_faf78681": {
    "message": "Doppelkreuz"
  },
  "down_5831a426": {
    "message": "Nach unten"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Diagonaler Pfeil nach unten links"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Diagonaler Pfeil nach unten rechts"
  },
  "download_filename_2baae924": {
    "message": "{ filename } herunterladen"
  },
  "downward_arrow_cca52012": {
    "message": "Abwärtspfeil"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Nach unten zeigendes Dreieck"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Eine Datei hierher ziehen"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Drag-and-Drop oder klicken Sie, um Ihren Computer zu durchsuchen."
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Ziehpunkt Die Aufwärts- und Abwärtspfeile verwenden, um die Größe zu ändern"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Fällig: Mehrere Daten"
  },
  "due_when_7eed10c6": {
    "message": "Fällig: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Alt-Text für diese Symbol-Instanz bearbeiten"
  },
  "edit_c5fbea07": {
    "message": "Ändern"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Link zum Bearbeiten des Kurses"
  },
  "edit_equation_f5279959": {
    "message": "Gleichung bearbeiten"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Vorhandenes Icon Maker-Symbol bearbeiten"
  },
  "edit_icon_2c6b0e91": {
    "message": "Symbol für Bearbeiten"
  },
  "edit_link_7f53bebb": {
    "message": "Link bearbeiten"
  },
  "editor_status_bar_653f44ee": {
    "message": "Statusleiste des Editors"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element beginnt mit { start }"
  },
  "embed_828fac4a": {
    "message": "Einbetten"
  },
  "embed_code_314f1bd5": {
    "message": "Code einbetten"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Content aus externem Tool einbetten"
  },
  "embed_image_1080badc": {
    "message": "Bild einbetten"
  },
  "embed_video_a97a64af": {
    "message": "Video einbetten"
  },
  "embedded_content_aaeb4d3d": {
    "message": "Eingebettete Inhalte"
  },
  "empty_set_91a92df4": {
    "message": "Leeres Set"
  },
  "encircled_dot_8f5e51c": {
    "message": "Eingekreister Punkt"
  },
  "encircled_minus_72745096": {
    "message": "Eingekreistes Minus"
  },
  "encircled_plus_36d8d104": {
    "message": "Eingekreistes Plus"
  },
  "encircled_times_5700096d": {
    "message": "Eingekreiste Zeiten"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Engineering-Symbol"
  },
  "english_icon_25bfe845": {
    "message": "Englisch-Symbol"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Geben Sie einen Medientitel ein"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Geben Sie für die Suche mindestens 3 Zeichen ein."
  },
  "enter_replacement_text_17631bbc": {
    "message": "Ersatztext eingeben"
  },
  "enter_search_text_26cb4459": {
    "message": "Suchtext eingeben"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Variante)"
  },
  "equals_sign_c51bdc58": {
    "message": "Gleichheitszeichen"
  },
  "equation_1c5ac93c": {
    "message": "Gleichung"
  },
  "equation_editor_39fbc3f1": {
    "message": "Formel-Editor"
  },
  "equilibrium_6ff3040b": {
    "message": "Equilibrium"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Äquivalenzklasse"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Äquivalent (Identität)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Ist vorhanden"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Vollbildschirm verlassen"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Vorschau standardmäßig erweitern"
  },
  "expand_to_see_types_f5d29352": {
    "message": "{ types } erweitern"
  },
  "external_link_d3f9e62a": {
    "message": "Externer Link"
  },
  "external_tool_frame_70b32473": {
    "message": "Rahmen für externe Werkzeuge"
  },
  "external_tools_6e77821": {
    "message": "Externe Tools"
  },
  "extra_large_b6cdf1ff": {
    "message": "Extra groß"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Extra groß ({ width } x { height } px)"
  },
  "extra_small_9ae33252": {
    "message": "Extra klein"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Außerschulisches Symbol"
  },
  "f_function_fe422d65": {
    "message": "F (Funktion)"
  },
  "fail_544e5dde": {
    "message": "NICHT BESTANDEN"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Abruf der Dateiinhalte fehlgeschlagen"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Inhalt konnte nicht von externem Tool abgerufen werden"
  },
  "file_name_8fd421ff": {
    "message": "Dateiname"
  },
  "file_preview_21667a6e": {
    "message": "Dateivorschau"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Dateivorschau für { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Dateispeicherquote überschritten"
  },
  "file_url_c12b64be": {
    "message": "Datei-URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "Dateisymbol für { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Bildvorschau für { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Textvorschau für { filename }"
  },
  "files_c300e900": {
    "message": "Dateien"
  },
  "files_index_af7c662b": {
    "message": "Dateienindex"
  },
  "find_8d605019": {
    "message": "Suchen"
  },
  "find_and_replace_6e345933": {
    "message": "Finden und Ersetzen"
  },
  "finish_bc343002": {
    "message": "Beenden"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Feste Überschriftshierarchie"
  },
  "flat_music_76d5a5c3": {
    "message": "Vermindert (Musik)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Symbolleiste für Element-Optionen fokussieren"
  },
  "folder_tree_fbab0726": {
    "message": "Ordnerstruktur"
  },
  "for_all_b919f972": {
    "message": "Für Alle"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Format als Liste"
  },
  "formatting_5b143aa8": {
    "message": "Formatierung"
  },
  "forward_slash_3f90f35e": {
    "message": "Schrägstrich"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Automatisch gespeicherte Inhalte gefunden"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Gefundene { count, plural,\n     =0 {# Ergebnisse}\n    one {# Ergebnisse}\n  other {# Ergebnisse}\n}"
  },
  "fraction_41bac7af": {
    "message": "Bruch"
  },
  "fullscreen_873bf53f": {
    "message": "Vollbild"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Vorschau wird erzeugt ..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Bilder im GIF-/PNG-Format, die größer als { size } KB sind, werden derzeit nicht unterstützt."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Gehen Sie zur Editor-Menüleiste"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Gehen Sie zur Editor-Symbolleiste"
  },
  "grades_a61eba0a": {
    "message": "Noten"
  },
  "graphics_text_bc9568bc": {
    "message": "Text für Grafik"
  },
  "greater_than_e98af662": {
    "message": "Größer als"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Größer oder gleich"
  },
  "greek_65c5b3f7": {
    "message": "Griechisch"
  },
  "green_15af4778": {
    "message": "Grün"
  },
  "grey_a55dceff": {
    "message": "Grau"
  },
  "group_documents_8bfd6ae6": {
    "message": "Gruppendokumente"
  },
  "group_files_4324f3df": {
    "message": "Gruppendateien"
  },
  "group_files_82e5dcdb": {
    "message": "Gruppendateien"
  },
  "group_images_98e0ac17": {
    "message": "Gruppenbilder"
  },
  "group_isomorphism_45b1458c": {
    "message": "Gruppenisomorphismus"
  },
  "group_link_63e626b3": {
    "message": "Gruppenverknüpfung"
  },
  "group_links_9493129e": {
    "message": "Gruppen-Links"
  },
  "group_media_2f3d128a": {
    "message": "Gruppenmedien"
  },
  "group_navigation_99f191a": {
    "message": "Gruppennavigation"
  },
  "h_bar_bb94deae": {
    "message": "H Bar"
  },
  "hat_ea321e35": {
    "message": "Hut"
  },
  "header_column_f27433cb": {
    "message": "Überschrift Spalte"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Überschrift Zeile und Spalte"
  },
  "header_row_f33eb169": {
    "message": "Überschrift Zeile"
  },
  "heading_2_5b84eed2": {
    "message": "Überschrift 2"
  },
  "heading_3_2c83de44": {
    "message": "Überschrift 3"
  },
  "heading_4_b2e74be7": {
    "message": "Überschrift 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Überschrift { h } angewendet"
  },
  "heading_h_removed_745f24a6": {
    "message": "Überschrift { h } entfernt"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Die Überschriftsebene darf nicht übersprungen werden."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Überschrift beginnt mit { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Überschriften dürfen nicht länger als 120 Zeichen sein."
  },
  "health_icon_8d292eb5": {
    "message": "Gesundheitssymbol"
  },
  "hearts_suit_e50e04ca": {
    "message": "Herz (Spielkartenfarbe)"
  },
  "height_69b03e15": {
    "message": "Höhe"
  },
  "hexagon_d8468e0d": {
    "message": "Sechseck"
  },
  "hide_description_bfb5502e": {
    "message": "Beschreibung ausblenden"
  },
  "hide_title_description_caf092ef": {
    "message": "Beschreibung { title } ausblenden"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Markieren Sie ein Element, um die Symbolleiste für die Elementoptionen zu aktivieren."
  },
  "home_351838cd": {
    "message": "Start"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Wie kann ich Untertitel anfordern und bearbeiten?"
  },
  "html_code_editor_fd967a44": {
    "message": "HTML-Code-Editor"
  },
  "html_editor_fb2ab713": {
    "message": "HTML-Editor"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Ich habe die Berechtigung zur Nutzung dieser Datei erhalten."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Ich bin der Urheberrechtsinhaber"
  },
  "icon_215a1dc6": {
    "message": "Symbol"
  },
  "icon_8168b2f8": {
    "message": "Symbol"
  },
  "icon_color_b86dd6d6": {
    "message": "Symbolfarbe"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Icon Maker-Symbole"
  },
  "icon_options_7e32746e": {
    "message": "Symbol-Optionen"
  },
  "icon_options_tray_2b407977": {
    "message": "Auswahl Symbol-Optionen"
  },
  "icon_preview_1782a1d9": {
    "message": "Symbol-Vorschau"
  },
  "icon_shape_30b61e7": {
    "message": "Symbolform"
  },
  "icon_size_9353edea": {
    "message": "Symbolgröße"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Wenn Sie nichts eingeben, wird der Linktext als Name des Kurslinks angezeigt."
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Wenn Nutzungsrechte erforderlich sind, wird die Datei erst veröffentlicht, wenn sie auf der Seite Dateien aktiviert wurde."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Wenn Sie jetzt keine Nutzungsrechte auswählen, wird diese Datei nach dem Hochladen nicht veröffentlicht."
  },
  "image_8ad06": {
    "message": "Bild"
  },
  "image_c1c98202": {
    "message": "Bild"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Bilddateinamen dürfen für das Alt-Attribut zur Beschreibung des Bildinhalts nicht verwendet werden."
  },
  "image_options_5412d02c": {
    "message": "Bildoptionen"
  },
  "image_options_tray_90a46006": {
    "message": "Fach für Bildoptionen"
  },
  "image_to_crop_3a34487d": {
    "message": "Bild zum Zuschneiden"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Bild mit dem Dateinamen { file }"
  },
  "images_7ce26570": {
    "message": "Bilder"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Bilder müssen ein Alt-Attribut zur Beschreibung des Bildinhalts haben."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Imaginärer Teil (einer komplexen Zahl)"
  },
  "in_element_of_19ca2f33": {
    "message": "In (Element von)"
  },
  "increase_indent_6af90f7c": {
    "message": "Einzug vergrößern"
  },
  "increase_rich_content_area_340b775": {
    "message": "Rich-Content-Bereich vergrößern"
  },
  "indefinite_integral_6623307e": {
    "message": "Unbestimmtes Integral"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } von { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Schlussfolgerung"
  },
  "infinity_7a10f206": {
    "message": "Unendlichkeit"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Eingabefeld für Alpha"
  },
  "input_field_for_blue_561e020a": {
    "message": "Eingabefeld für Blau"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Eingabefeld für Grün"
  },
  "input_field_for_red_86a84615": {
    "message": "Eingabefeld für Rot"
  },
  "insert_593145ef": {
    "message": "Einfügen"
  },
  "insert_link_6dc23cae": {
    "message": "Link einfügen"
  },
  "insert_math_equation_57c6e767": {
    "message": "Math. Gleichung einfügen"
  },
  "integers_336344e1": {
    "message": "Ganze Zahlen"
  },
  "intersection_cd4590e4": {
    "message": "Schnittfläche"
  },
  "invalid_description_991e23bb": {
    "message": "Ungültige Beschreibung"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Ungültiger Eintrag."
  },
  "invalid_file_c11ba11": {
    "message": "Ungültiger Dateityp"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Ungültiger Dateityp"
  },
  "invalid_url_cbde79f": {
    "message": "Ungültige URL"
  },
  "iota_11c932a9": {
    "message": "Jota"
  },
  "issue_num_total_f94536cf": {
    "message": "Fehler { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Kursivschrift angewendet"
  },
  "italic_removed_17cbab6f": {
    "message": "Kursivschrift entfernt"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Variante)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Tastenkombinationen"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Tastaturnavigation zu Links mithilfe der Tabulatortaste. Zwei benachbarte Links, die direkt zum gleichen Ziel führen, können für den Tastaturbenutzer verwirrend sein."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Symbol für „Sprachkunst“"
  },
  "languages_icon_9d20539": {
    "message": "Sprachen-Symbol"
  },
  "large_9c5e80e7": {
    "message": "Groß"
  },
  "large_text_e7ba08cd": {
    "message": "Großer Text"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Groß ({ width } x { height } px)"
  },
  "learn_ad3b3505": {
    "message": "Lernen"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Weitere Informationen über nebenstehende Links"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Weitere Informationen über Farbkontrast"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Weitere Informationen über das Organisieren der Seitenüberschriften"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Erfahren Sie mehr über die richtige Struktur von Seitenüberschriften"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Weitere Informationen über Tabellenkopfzeilen"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Weitere Informationen zur Verwendung von alternativem Text für Bilder"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Weitere Informationen zur Verwendung von Tabellenbeschriftungen"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Weitere Informationen zur Verwendung von Dateinamen als alternativen Text"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Weitere Informationen zur Verwendung von Listen"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Weitere Informationen zur Verwendung von Bereichsattributen bei Tabellen"
  },
  "leave_as_is_4facfe55": {
    "message": "Lassen, wie es ist"
  },
  "left_3ea9d375": {
    "message": "Links"
  },
  "left_align_43d95491": {
    "message": "Linksbündig"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Spitze Klammer links"
  },
  "left_arrow_4fde1a64": {
    "message": "Pfeil nach links"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Pfeil nach links mit Haken"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Obergrenze links"
  },
  "left_curly_brace_1726fb4": {
    "message": "Geschweifte Klammer links"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Harpunenpfeil nach links unten"
  },
  "left_floor_29ac2274": {
    "message": "Linker Boden"
  },
  "left_to_right_e9b4fd06": {
    "message": "Von links nach rechts"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Harpunenpfeil nach links oben"
  },
  "leftward_arrow_1e4765de": {
    "message": "Pfeil nach links"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Nach links zeigendes Dreieck"
  },
  "less_than_a26c0641": {
    "message": "Kleiner als"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Kleiner oder gleich"
  },
  "library_icon_ae1e54cf": {
    "message": "Bibliothekssymbol"
  },
  "light_blue_5374f600": {
    "message": "Hellblau"
  },
  "link_7262adec": {
    "message": "Link"
  },
  "link_options_a16b758b": {
    "message": "Link-Optionen"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "Link-Typ: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Link mit Text, beginnend mit { start }"
  },
  "links_14b70841": {
    "message": "Links"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Links zu einer externen Website"
  },
  "lists_cd1336fc": {
    "message": "Listen"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Listen sollten als Listen formatiert werden."
  },
  "load_more_35d33c7": {
    "message": "Mehr laden"
  },
  "loading_25990131": {
    "message": "Wird geladen ..."
  },
  "loading_bde52856": {
    "message": "Wird geladen"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Das Laden von Untertitel ist fehlgeschlagen."
  },
  "loading_external_tool_d839042c": {
    "message": "Externes Tool wird geladen"
  },
  "loading_failed_b3524381": {
    "message": "Ladevorgang fehlgeschlagen"
  },
  "loading_failed_e6a9d8ef": {
    "message": "Ladevorgang fehlgeschlagen"
  },
  "loading_folders_d8b5869e": {
    "message": "Ordner werden geladen"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Laden des Platzhalters für { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Ladevorgang, bitte warten"
  },
  "loading_preview_9f077aa1": {
    "message": "Vorschau wird geladen"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Geschwindigkeit bei 1x sperren"
  },
  "locked_762f138b": {
    "message": "Gesperrt"
  },
  "logical_equivalence_76fca396": {
    "message": "Logisch äquivalent"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Logisch äquivalent (kurz)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Logisch äquivalent (kurz und dick)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Logisch äquivalent (dick)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Horizontale Punkte unten"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Zuordnung zu"
  },
  "math_icon_ad4e9d03": {
    "message": "Symbol „Mathematik“"
  },
  "media_af190855": {
    "message": "Medien"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Mediendatei wird verarbeitet. Versuchen Sie es später noch einmal."
  },
  "media_options_saved_560c4ec8": {
    "message": "Medienoptionen gespeichert."
  },
  "media_title_2112243b": {
    "message": "Medien-Titel"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Mittel ({ width } x { height } px)"
  },
  "merge_links_2478df96": {
    "message": "Links zusammenführen"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon deaktiviert"
  },
  "middle_27dc1d5": {
    "message": "Mitte"
  },
  "minimize_file_preview_da911944": {
    "message": "Dateivorschau minimieren"
  },
  "minimize_video_20aa554b": {
    "message": "Video minimieren"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/Plus"
  },
  "misc_3b692ea7": {
    "message": "Sonstige"
  },
  "miscellaneous_e9818229": {
    "message": "Verschiedenes"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Module"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Bild zum Zuschneiden von { directionWord } verschieben "
  },
  "mu_37223b8b": {
    "message": "My"
  },
  "multi_color_image_63d7372f": {
    "message": "Mehrfarbiges Bild"
  },
  "multiplication_sign_15f95c22": {
    "message": "Multiplikationszeichen"
  },
  "music_icon_4db5c972": {
    "message": "Musiksymbol"
  },
  "my_files_2f621040": {
    "message": "Meine Dateien"
  },
  "n_th_root_9991a6e4": {
    "message": "Nte. Wurzel"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Name"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Auflösungszeichen (Musik)"
  },
  "natural_numbers_3da07060": {
    "message": "Natürliche Zahlen"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navigieren Sie durch das Menü oder die Symbolleiste"
  },
  "navigation_ee9af92d": {
    "message": "Navigation"
  },
  "nested_greater_than_d852e60d": {
    "message": "Geschachtelt größer als"
  },
  "nested_less_than_27d17e58": {
    "message": "Geschachtelt kleiner als"
  },
  "new_quiz_34aacba6": {
    "message": "Neues Quiz"
  },
  "next_40e12421": {
    "message": "Weiter"
  },
  "next_findtext_9d69f0fe": {
    "message": "Nächster { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Es wurden keine Zugangsprobleme festgestellt."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Es wurden noch keine Ankündigungen erstellt."
  },
  "no_announcements_found_20185afc": {
    "message": "Keine Ankündigungen gefunden."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Es wurden noch keine Aufgaben erstellt."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Keine Aufgaben gefunden."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Keine Änderungen zu speichern."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Es wurden noch keine Diskussionen erstellt."
  },
  "no_discussions_found_9284063b": {
    "message": "Keine Diskussionen gefunden."
  },
  "no_e16d9132": {
    "message": "Nein"
  },
  "no_file_chosen_9a880793": {
    "message": "Keine Datei ausgewählt"
  },
  "no_headers_9bc7dc7f": {
    "message": "Keine Header"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Es wurden noch keine Module erstellt."
  },
  "no_modules_found_2df43a40": {
    "message": "Keine Module gefunden."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Es wurden noch keine Seiten erstellt."
  },
  "no_pages_found_6799350": {
    "message": "Keine Seiten gefunden."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Für diese Datei ist keine Vorschau verfügbar."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Es wurden noch keine Quizze erstellt."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Keine Quizze gefunden."
  },
  "no_results_940393cf": {
    "message": "Keine Ergebnisse."
  },
  "no_results_found_58717065": {
    "message": "Keine Ergebnisse gefunden"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Es wurden keine Ergebnisse für { filterTerm } gefunden."
  },
  "no_video_1ed00b26": {
    "message": "Kein Video"
  },
  "none_3b5e34d2": {
    "message": "Keine"
  },
  "none_selected_b93d56d2": {
    "message": "Keines ausgewählt"
  },
  "normal_text_7b03da48": {
    "message": "Normaler Text"
  },
  "not_equal_6e2980e6": {
    "message": "Ungleich"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Nicht in (kein Element von)"
  },
  "not_negation_1418ebb8": {
    "message": "Nicht (Negation)"
  },
  "not_subset_dc2b5e84": {
    "message": "Keine Teilmenge"
  },
  "not_subset_strict_23d282bf": {
    "message": "Keine Teilmenge (Streng)"
  },
  "not_superset_5556b913": {
    "message": "Keine Obermenge"
  },
  "not_superset_strict_24e06f36": {
    "message": "Keine Obermenge (Streng)"
  },
  "nu_1c0f6848": {
    "message": "Ny"
  },
  "octagon_e48be9f": {
    "message": "Achteck"
  },
  "olive_6a3e4d6b": {
    "message": "Olive"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Zum Speichern eines Symbols muss einer der folgenden Stile hinzugefügt werden: Symbolfarbe, Umrissgröße, Symboltext oder Bild"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Eine oder mehrere Dateien konnten nicht eingefügt werden. Versuchen Sie, die Dateien hochzuladen oder zu ziehen und abzulegen."
  },
  "open_circle_e9bd069": {
    "message": "Offener Kreis"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Diesen Tastenkombinationsdialog öffnen"
  },
  "open_title_application_fd624fc5": {
    "message": "Anwendung { title } öffnen"
  },
  "operators_a2ef9a93": {
    "message": "Operatoren"
  },
  "options_3ab0ea65": {
    "message": "Optionen"
  },
  "or_9b70ccaa": {
    "message": "Oder"
  },
  "orange_81386a62": {
    "message": "Orange"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Geordnete und ungeordnete Listen"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Weitere Editor-Tastenkombinationen finden Sie unter"
  },
  "outline_color_3ef2cea7": {
    "message": "Umrissfarbe"
  },
  "outline_size_a6059a21": {
    "message": "Umrissgröße"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } ist kein gültiges Protokoll."
  },
  "page_50c4823d": {
    "message": "Seite"
  },
  "pages_e5414c2c": {
    "message": "Seiten"
  },
  "paragraph_5e5ad8eb": {
    "message": "Absatz"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Absatz angewendet"
  },
  "paragraph_removed_d09320e": {
    "message": "Absatz entfernt"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Absatz, beginnend mit { start }"
  },
  "parallel_d55d6e38": {
    "message": "Parallel"
  },
  "partial_derivative_4a9159df": {
    "message": "Teilweise (abgeleitet)"
  },
  "pass_1c19a2b3": {
    "message": "BESTANDEN"
  },
  "paste_5963d1c1": {
    "message": "Einfügen"
  },
  "pause_12af3bb4": {
    "message": "Pause"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagon"
  },
  "people_b4ebb13c": {
    "message": "Teilnehmer*innen"
  },
  "percentage_34ab7c2c": {
    "message": "Prozentsatz"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Prozentsatz muss eine Zahl sein"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Der Prozentsatz muss mindestens { percentage }% betragen"
  },
  "performing_arts_icon_f3497486": {
    "message": "Symbol für „Darstellende Kunst“"
  },
  "perpendicular_7c48ede4": {
    "message": "Senkrecht"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Variante)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Symbol Für Körperertüchtigung"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Variante)"
  },
  "pick_a_color_557abfb0": {
    "message": "Farbe auswählen"
  },
  "pink_68ad45cb": {
    "message": "Rosa"
  },
  "pixels_52ece7d1": {
    "message": "Pixel"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Pixel müssen mindestens { width } x { height } px betragen."
  },
  "play_1a47eaa7": {
    "message": "Abspielen"
  },
  "play_media_comment_35257210": {
    "message": "Medienkommentar wiedergeben"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Medienkommentar durch { name } von { createdAt } wiedergeben."
  },
  "player_layout_14e09a29": {
    "message": "Player-Layout"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Bitte erlauben Sie Canvas, auf Ihr Mikrofon und Ihre Webcam zuzugreifen."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Bitte wählen Sie eine Datei"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Bitte geben Sie einen Dateinamen ein"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Bitte geben Sie eine gültige Video-URL von einer unterstützten Plattform ein."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Bitte wählen Sie eine Datei mit einem unterstützten Typ"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/Minus"
  },
  "posted_when_a578f5ab": {
    "message": "Gepostet am: { when }"
  },
  "power_set_4f26f316": {
    "message": "Potenzmenge"
  },
  "precedes_196b9aef": {
    "message": "Vorrangig"
  },
  "precedes_equal_20701e84": {
    "message": "Vorrangig oder gleich"
  },
  "preformatted_d0670862": {
    "message": "Vorformatiert"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Vorher"
  },
  "preview_53003fd2": {
    "message": "Vorschau"
  },
  "preview_a3f8f854": {
    "message": "VORSCHAU"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Vorschau in Overlay"
  },
  "preview_inline_9787330": {
    "message": "Inline-Vorschau"
  },
  "previous_bd2ac015": {
    "message": "Vorherige"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Vorheriger { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Zuvor ausgewählte Farben"
  },
  "prime_917ea60e": {
    "message": "Primzahl"
  },
  "prime_numbers_13464f61": {
    "message": "Primzahlen"
  },
  "product_39cf144f": {
    "message": "Produkt"
  },
  "proportional_f02800cc": {
    "message": "Proportional"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Das Protokoll muss ftp, http, https, mailto, Skype oder tel sein oder weggelassen werden."
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "veröffentlicht"
  },
  "published_when_302d8e23": {
    "message": "Veröffentlicht am: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Kürbis"
  },
  "purple_7678a9fc": {
    "message": "Violett"
  },
  "quaternions_877024e0": {
    "message": "Quaternionen"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Quizze"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rationale Zahlen"
  },
  "real_numbers_7c99df94": {
    "message": "Reelle Zahlen"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Reeller Teil (einer komplexen Zahl)"
  },
  "record_7c9448b": {
    "message": "Aufnehmen"
  },
  "record_upload_media_5fdce166": {
    "message": "Medien aufzeichnen/hochladen"
  },
  "recording_98da6bda": {
    "message": "Aufzeichnung"
  },
  "red_8258edf3": {
    "message": "Rot"
  },
  "relationships_6602af70": {
    "message": "Beziehungen"
  },
  "religion_icon_246e0be1": {
    "message": "Religionssymbol"
  },
  "remove_f47dc62a": {
    "message": "Entfernen"
  },
  "remove_filename_3ea029f6": {
    "message": "{ filename } entfernen"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Überschriftsstil entfernen"
  },
  "remove_link_d1f2f4d0": {
    "message": "Link entfernen"
  },
  "replace_all_d3d68b3": {
    "message": "Alle ersetzen"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Alle { findText } mit { replaceText } ersetzen"
  },
  "replace_e61834a7": {
    "message": "Ersetzen"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "{ findText } mit { replaceText } ersetzen"
  },
  "replace_with_eeff01ad": {
    "message": "Ersetzen mit"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "{ alertFindText } mit { alertReplaceText } ersetzt"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Alle { alertFindText } mit { alertReplaceText } ersetzt"
  },
  "reset_95a81614": {
    "message": "Zurücksetzen"
  },
  "resize_ec83d538": {
    "message": "Größe ändern"
  },
  "restore_auto_save_deccd84b": {
    "message": "Automatisches Speichern wiederherstellen"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Ergebnis { index } von { max }"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Reverses Drehkreuz (kein Ergebnis)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Variante)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Rich-Content-Editor"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Rich-Text-Bereich. Drücken Sie { OSKey }+F8 für Tastenkombinationen im Rich Content Editor."
  },
  "right_71ffdc4d": {
    "message": "Rechts"
  },
  "right_align_39e7a32a": {
    "message": "Rechtsbündig"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Eckige Klammer links"
  },
  "right_arrow_35e0eddf": {
    "message": "Pfeil nach rechts"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Pfeil nach rechts mit Haken"
  },
  "right_ceiling_839dc744": {
    "message": "Obergrenze rechts"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Geschweifte Klammer rechts"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Harpunenpfeil nach rechts unten"
  },
  "right_floor_5392d5cf": {
    "message": "Rechter Boden"
  },
  "right_to_left_9cfb092a": {
    "message": "Von rechts nach links"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Harpunenpfeil nach rechts oben"
  },
  "rightward_arrow_32932107": {
    "message": "Pfeil nach rechts"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Nach rechts zeigendes Dreieck"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Bild -90 Grad drehen"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Bild 90 Grad drehen"
  },
  "rotation_9699c538": {
    "message": "Drehung"
  },
  "row_fc0944a7": {
    "message": "Zeile"
  },
  "row_group_979f5528": {
    "message": "Zeilengruppe"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Leider ist der Pretty HTML-Editor nicht über die Tastatur zugänglich. Den Editor für reines HTML finden Sie hier."
  },
  "save_11a80ec3": {
    "message": "Speichern"
  },
  "save_copy_ca63944e": {
    "message": "Kopie speichern"
  },
  "save_media_cb9e786e": {
    "message": "Medien speichern"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Icon Maker-Symbole gespeichert"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Ohne alternativen Text kann ein Bildschirmbetrachter nicht bestimmen, was auf einem Bild gezeigt wird, zumal die Dateinamen oft sinnlose Zeichenfolgen aus Zahlen und Buchstaben sind, die weder den Kontext noch die Bedeutung erläutern."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Ohne alternativen Text, der den Kontext und die Bedeutung erläutert, kann ein Bildschirmbetrachter nicht bestimmen, was auf einem Bild gezeigt wird. Alternativer Text sollte einfach und präzise sein."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Ohne alternativen Text, der den Kontext und die Bedeutung erläutert, kann ein Bildschirmbetrachter nicht bestimmen, was auf einem Bild gezeigt wird."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Bildschirmbetrachter können Tabellen ohne die entsprechende Struktur nicht interpretieren. Tabellenüberschriften liefern die Richtung und den Anwendungsbereich des Inhalts."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Bildschirmbetrachter können Tabellen ohne die entsprechende Struktur nicht interpretieren. Tabellenbeschriftungen beschreiben den Kontext und die allgemeine Bedeutung der Tabelle."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Bildschirmbetrachter können Tabellen ohne die entsprechende Struktur nicht interpretieren. Tabellenüberschriften weisen die Richtung und geben eine Übersicht über den Inhalt."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Suchen"
  },
  "select_audio_source_21043cd5": {
    "message": "Audioquelle auswählen"
  },
  "select_crop_shape_d441feeb": {
    "message": "Zuschnittsform auswählen"
  },
  "select_language_7c93a900": {
    "message": "Sprache auswählen"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Videoquelle auswählen"
  },
  "selected_274ce24f": {
    "message": "Ausgewählt"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Ausgewählter { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Auswahl"
  },
  "set_header_scope_8c548f40": {
    "message": "Den Anwendungsbereich der Überschrift festlegen"
  },
  "set_minus_b46e9b88": {
    "message": "Mal minus 1"
  },
  "set_table_header_cfab13a0": {
    "message": "Tabellenüberschrift festlegen"
  },
  "sharp_music_ab956814": {
    "message": "Erhöhungszeichen (Musik)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Pfeile"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O, um den Pretty HTML-Editor zu öffnen."
  },
  "shortcut_911d6255": {
    "message": "Shortcut"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Bildoptionen anzeigen"
  },
  "show_link_options_545338fd": {
    "message": "Link-Optionen anzeigen"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Laufendes Transkript anzeigen"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Laufendes Transkript anzeigen"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Sehende Benutzer*innen durchsuchen Webseiten schnell nach groß- oder fettgedruckten Überschriften. Benutzer*innen von Bildschirmbetrachtern sind für ein kontextbezogenes Verständnis auf Überschriften angewiesen. Überschriften sollten die entsprechende Struktur verwenden."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Sehende Benutzer*innen durchsuchen Webseiten schnell nach groß- oder fettgedruckten Überschriften. Benutzer*innen von Bildschirmbetrachtern sind für ein kontextbezogenes Verständnis auf Überschriften angewiesen. Überschriften sollten die entsprechende Struktur knapp wiedergeben."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Variante)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Einfarbiges Bild"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Einfarbige Bildfarbe"
  },
  "size_b30e1077": {
    "message": "Größe"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Die Größe der Untertiteldatei ist größer als die maximal zulässige Dateigröße von { max } KB."
  },
  "small_b070434a": {
    "message": "Klein"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Klein ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Geschlossener Kreise"
  },
  "something_went_wrong_89195131": {
    "message": "Etwas ging schief."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Beim Zugriff auf Ihre Webcam ging etwas schief."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Etwas ist schiefgelaufen und ich weiß nicht, was ich anzeigen soll."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Etwas ging schief. Überprüfen Sie Ihre Verbindung, laden Sie die Seite noch einmal und versuchen Sie es erneut."
  },
  "something_went_wrong_d238c551": {
    "message": "Etwas ging schief."
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Beim Teilen Ihres Bildschirms trat ein Fehler auf."
  },
  "sort_by_e75f9e3e": {
    "message": "Sortieren nach"
  },
  "spades_suit_b37020c2": {
    "message": "Pik (Spielkartenfarbe)"
  },
  "square_511eb3b3": {
    "message": "Viereck"
  },
  "square_cap_9ec88646": {
    "message": "Quadratische Cap"
  },
  "square_cup_b0665113": {
    "message": "Quadratische Cup"
  },
  "square_root_e8bcbc60": {
    "message": "Quadratwurzel"
  },
  "square_root_symbol_d0898a53": {
    "message": "Quadratwurzelsymbol"
  },
  "square_subset_17be67cb": {
    "message": "Quadratische Teilmenge"
  },
  "square_subset_strict_7044e84f": {
    "message": "Quadratische Teilmenge (Streng)"
  },
  "square_superset_3be8dae1": {
    "message": "Quadratische Obermenge"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Quadratische Obermenge (Streng)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "Ungeordnete Liste abgleichen"
  },
  "star_8d156e09": {
    "message": "Stern"
  },
  "start_over_f7552aa9": {
    "message": "Nochmal beginnen"
  },
  "start_recording_9a65141a": {
    "message": "Aufzeichnung starten"
  },
  "steel_blue_14296f08": {
    "message": "Stahlblau"
  },
  "studio_media_options_ee504361": {
    "message": "Studio-Medienoptionen"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studio-Medienoptionen"
  },
  "styles_2aa721ef": {
    "message": "Styles"
  },
  "submit_a3cc6859": {
    "message": "Abgeben"
  },
  "submitting_b90fac62": {
    "message": "Wird abgegeben ..."
  },
  "subscript_59744f96": {
    "message": "Abonnieren"
  },
  "subset_19c1a92f": {
    "message": "Teilmenge"
  },
  "subset_strict_8d8948d6": {
    "message": "Teilmenge (Streng)"
  },
  "succeeds_9cc31be9": {
    "message": "Erfolgreich"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Folgt Gleich"
  },
  "sum_b0842d31": {
    "message": "Summe"
  },
  "superscript_8cb349a2": {
    "message": "Hochgestellt"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Hochgestellt und Tiefgestellt"
  },
  "superset_c4db8a7a": {
    "message": "Obermenge"
  },
  "superset_strict_c77dd6d2": {
    "message": "Obermenge (Streng)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Unterstützte Dateitypen: SRT oder WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Zum Pretty HTML-Editor wechseln"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Zum nur-HTML-Editor wechseln"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Zum HTML-Editor wechseln"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Zum Rich-Text-Editor wechseln"
  },
  "syllabus_f191f65b": {
    "message": "Kursplan"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Die Audiosignale des Systems sind erlaubt."
  },
  "system_audio_disabled_c177bd13": {
    "message": "Die Audiosignale des Systems sind deaktiviert."
  },
  "tab_arrows_4cf5abfc": {
    "message": "<TAB>/Pfeile"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Tabellenüberschriften, beginnend mit { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabelle, beginnend mit { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Tabellenüberschriften sollten den Geltungsbereich angeben."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tabellen sollten über eine Bildunterschrift verfügen, die den Inhalt der Tabelle beschreibt."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tabellen sollten mindestens eine Überschrift haben."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Blaugrün"
  },
  "text_7f4593da": {
    "message": "Text"
  },
  "text_background_color_16e61c3f": {
    "message": "Texthintergrundfarbe"
  },
  "text_color_acf75eb6": {
    "message": "Textfarbe"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Der Text ist, insbesondere für Menschen mit Sehschwäche, schwer zu lesen, wenn der Kontrast zwischen Text und Hintergrund nicht ausreicht."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Text, der größer als 18 Punkte ist (bei Fettdruck 14 Punkte), sollte einen Mindestkontrastverhältnis von 3:1 haben."
  },
  "text_optional_384f94f7": {
    "message": "Text (optional)"
  },
  "text_position_8df8c162": {
    "message": "Textposition"
  },
  "text_size_887c2f6": {
    "message": "Textgröße"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Text, der kleiner als 18 Punkte ist (bei Fettdruck 14 Punkte), sollte einen Mindestkontrastverhältnis von 4,5:1 haben."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Die Dokumentvorschau wird gerade ausgeführt. Versuchen Sie es später noch einmal."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Die erste Überschrift auf einer Seite sollte eine H2-Überschrift sein."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Die Höhe des Rich-Content-Bereichs wurde verringert."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Die Höhe des Rich-Content-Bereichs wurde vergrößert."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Das Material ist gemeinfrei."
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Das Material ist unter Creative Commons lizenziert."
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Das Material unterliegt einer Ausnahme – z. B. Fair Use, das Recht zum Zitieren oder anderen nach geltendem Urheberrecht."
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Der Pretty HTML-Editor ist nicht über die Tastatur zugänglich. Shift-O, um den Editor für reines HTML zu öffnen."
  },
  "therefore_d860e024": {
    "message": "Daher"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Variante)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Dicker Abwärtspfeil"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Dicker Pfeil nach links"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Dicker Pfeil nach links"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Dicker Pfeil nach rechts"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Dicker Pfeil nach rechts"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Dicker Aufwärtspfeil"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Dieses Dokument kann in Canvas nicht angezeigt werden."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Diese Gleichung kann in der Basisansicht nicht dargestellt werden."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Dieses Bild ist momentan nicht verfügbar."
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Dieses Video kann YouTube-Anzeigen enthalten."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Obwohl Ihr Video im Browser den korrekten Titel hat, konnten wir ihn in der Datenbank nicht aktualisieren."
  },
  "thumbnail_e0de666f": {
    "message": "Miniaturansicht"
  },
  "timebar_a4d18443": {
    "message": "Zeitleiste"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Der Titel darf nicht leer sein"
  },
  "title_ee03d132": {
    "message": "Titel"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Bereit für Post: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Zu erledigen: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "{ summary } Gruppe umschalten"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Quickinfo für Umschalten"
  },
  "tools_2fcf772e": {
    "message": "Tools"
  },
  "top_66e0adb6": {
    "message": "Oben"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Das Transkript-Fenster ist bei einer Breite von über 720 px verfügbar."
  },
  "tray_839df38a": {
    "message": "Fach"
  },
  "triangle_6072304e": {
    "message": "Dreieck"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Drehkreuz (Erträge)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "Geben Sie <Strg>+F9 ein, um auf die Bildoptionen zuzugreifen. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Geben Sie <Strg>+F9 ein, um auf die Link-Optionen zuzugreifen. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Geben Sie <Strg>+F9 ein, um auf die Tabellenoptionen zuzugreifen. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "URL für Ressourcenauswahl kann nicht bestimmt werden"
  },
  "underline_applied_ae01ec97": {
    "message": "Unterstreichung angewendet"
  },
  "underline_removed_3693e17c": {
    "message": "Unterstreichung entfernt"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "nicht veröffentlicht"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Ungespeicherte Änderungen gehen verloren."
  },
  "untitled_16aa4f2b": {
    "message": "Ohne Titel"
  },
  "untitled_efdc2d7d": {
    "message": "Ohne Titel"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Diagonaler Pfeil nach oben links"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Diagonaler Pfeil nach oben rechts"
  },
  "up_c553575d": {
    "message": "Nach oben"
  },
  "updated_link_a827e441": {
    "message": "Aktualisierter Link"
  },
  "upload_document_253f0478": {
    "message": "Dokument hochladen"
  },
  "upload_file_fd2361b8": {
    "message": "Datei hochladen"
  },
  "upload_image_6120b609": {
    "message": "Bild hochladen"
  },
  "upload_media_ce31135a": {
    "message": "Medien hochladen"
  },
  "upload_record_media_e4207d72": {
    "message": "Medien hochladen/aufzeichnen"
  },
  "uploading_19e8a4e7": {
    "message": "Wird hochgeladen"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "Alphabetisch geordnete Liste in Großbuchstaben"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta In Großbuchstaben"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma großgeschrieben"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda großgeschrieben"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega großgeschrieben"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi großgeschrieben"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi großgeschrieben"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi großgeschrieben"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "Nach römischen Zahlen geordnete Liste in Großbuchstaben"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma großgeschrieben"
  },
  "uppercase_theta_49afc891": {
    "message": "Theta großgeschrieben"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Ypsilon großgeschrieben"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi großgeschrieben"
  },
  "upsilon_33651634": {
    "message": "Ypsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Nach oben und unten zeigender Pfeil"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Nach oben und unten zeigender Pfeil (Dick)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Aufwärtspfeil"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Nach oben zeigendes Dreieck"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Nutzungsrecht:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Nutzungsrechte (erforderlich)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Navigieren Sie mit den Pfeiltasten in den Optionen."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Verwenden Sie die Pfeiltasten, um eine Form auszuwählen."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Verwenden Sie die Pfeiltasten, um eine Größe auszuwählen."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Verwenden Sie die Pfeiltasten, um eine Textposition auszuwählen."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Verwenden Sie die Pfeiltasten, um eine Textgröße auszuwählen."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Verwenden Sie die Pfeiltasten, um eine Konturgröße auszuwählen."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Wird von Screenreadern verwendet, um den Inhalt eines { TYPE } zu beschreiben."
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Verwendet von einem Screen-Reader zur Beschreibung des Inhalts eines Bilds"
  },
  "user_documents_c206e61f": {
    "message": "Meine Dokumente"
  },
  "user_files_78e21703": {
    "message": "Benutzerdateien"
  },
  "user_images_b6490852": {
    "message": "Meine Bilder"
  },
  "user_media_14fbf656": {
    "message": "Meine Medien"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (Notation)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Vertikale Leiste (Set Builder Notation)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Vertikale Punkte"
  },
  "video_options_24ef6e5d": {
    "message": "Videooptionen"
  },
  "video_options_tray_3b9809a5": {
    "message": "Fach für Videooptionen"
  },
  "video_player_b371005": {
    "message": "Videoplayer"
  },
  "video_player_for_9e7d373b": {
    "message": "Videoplayer für "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Videoplayer für { title }"
  },
  "video_url_889d3263": {
    "message": "Video-URL"
  },
  "view_all_e13bf0a6": {
    "message": "Alle anzeigen"
  },
  "view_ba339f93": {
    "message": "Anzeigen"
  },
  "view_description_30446afc": {
    "message": "Beschreibung anzeigen"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Tastenkombinationen anzeigen"
  },
  "view_title_description_67940918": {
    "message": "Beschreibung { title } anzeigen"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Wort- und Zeichenanzahl anzeigen"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Beschränkungen der Anzeige"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Wir konnten kein funktionierendes mit Ihrem Gerät verbundenes Mikrofon erkennen."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Wir konnten keine funktionierende mit Ihrem Gerät verbundene Webcam erkennen."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Wir konnten an Ihrem Gerät weder eine funktionierende Webcam noch ein Mikrofon erkennen."
  },
  "webcam_disabled_30c66986": {
    "message": "Die Webcam ist deaktiviert."
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Webseiten sollten nur eine einzige H1-Überschrift haben, die automatisch vom Titel der Seite verwendet wird. Die erste Überschrift in Ihrem Inhalt sollte eine H2-Überschrift sein."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Wenn Markup verwendet wird, das die Elemente optisch als Liste formatiert, die Listenbeziehung jedoch nicht zeigt, haben Benutzer*innen möglicherweise Schwierigkeiten, in diesen Informationen zu navigieren."
  },
  "white_87fa64fd": {
    "message": "Weiß"
  },
  "why_523b3d8c": {
    "message": "Warum?"
  },
  "width_492fec76": {
    "message": "Breite"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Breite und Höhe müssen Zahlen sein"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height } px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki-Startseite"
  },
  "word_count_c77fe3a6": {
    "message": "Wortzahl"
  },
  "words_b448b7d5": {
    "message": "Wörter"
  },
  "wreath_product_200b38ef": {
    "message": "Kranzprodukt"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ja"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Sie befinden sich auf einer Farbpalette. Um auf der Palette nach oben, links, unten oder rechts zu navigieren, verwenden Sie die Tasten „W“, „A“, „S“ und „D“."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Sie befinden sich auf einem Farbschieberegler. Um den Schieberegler nach links oder rechts zu bewegen, verwenden Sie die Tasten „A“ und „D“."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Sie befinden sich auf einem Alpha-Schieberegler. Um den Schieberegler nach links oder rechts zu bewegen, verwenden Sie die Tasten „A“ und „D“."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Sie haben nicht gespeicherte Änderungen im Icon Maker-Fach. Möchten Sie fortfahren, ohne diese Änderungen zu speichern?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Möglicherweise müssen Sie weitere Überschriften anpassen, um die Seitenhierarchie zu berücksichtigen."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Sie können keine leere Datei hochladen."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Ihr Bild wurde für Icon Maker komprimiert. Bilder mit einer Größe von weniger als { size } KB werden nicht komprimiert."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Ihr Mikrofon wird in den Browsereinstellungen blockiert."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Ihre Webcam und Ihr Mikrofon werden in den Browsereinstellungen blockiert."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Ihre Webcam wird in den Browsereinstellungen blockiert."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Ihre Webcam wird möglicherweise bereits benutzt."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "Einbettungs-URL von YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Bild vergrößern"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Bild verkleinern"
  }
};
formatMessage.addLocale({
  de: locale
});